import React, { useState, useRef, useEffect, Fragment } from "react";
import { Slider, Dropdown, Menu } from 'antd';
import { countNumDown, createTimeStr, enterFullScreen, exitFullScreen } from "utils/common";
import "./index.less";

const rateArr = [
    '2.0', '1.75', '1.5', '1.25', '1.0'
];


const VideoPage = ({id = "", poster = '', videoUrl = '', themeColor = '', isPlaybackRate = false, changeVideo, playNoVideo }) => {
    const videoWrapPlayer = useRef(null);
    const videoPlayer = useRef(null);
    const isEndRef = useRef(null);
    const playingRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isSupportFullScreen, setIsSupportFullScreen] = useState(false);
    const [showPoint, setShowPoint] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [playbackRate, setPlaybackRate] = useState('1.0');
    const [showPlaybackRate, setShowPlaybackRate] = useState(false);
    // 1倍、1.5倍、2倍
    const [playbackRateMap, setPlaybackRateMap] = useState([
        { label: "2x", value: "2.0" },
        { label: "1.75x", value: "1.75" },
        { label: "1.5x", value: 1.5 },
        { label: "1.25x", value: "1.25" },
        { label: "1x", value: "1.0" },
    ]);

    useEffect(()=>{
        changeSilderColor();
    },[])

    useEffect(()=>{
        if(!playing && videoPlayer.current && videoUrl) {
            pauseAll();
            videoPlayer.current.play();
        }
    },[videoUrl])

    //pc端鼠标移入事件
    const handleMouseEnter = () => {
        setShowPoint(true);
    }
    //pc端鼠标移出事件
    const handleMouseLeave = () => {
        setShowPoint(false);
    }
    //canplay事件
    const handleCanPlay = () => {
        //判断是否支持FullScreen
        let isSupportFullScreen = false;
        const videoElement = videoPlayer.current;
        if(typeof videoElement.requestFullscreen === "function"){
            isSupportFullScreen = true;
        }else if(typeof videoElement.webkitRequestFullScreen === "function"){
            isSupportFullScreen = true;
        }else if(typeof videoElement.mozRequestFullScreen === "function"){
            isSupportFullScreen = true;
        }else if(typeof videoElement.msRequestFullscreen === "function"){
            isSupportFullScreen = true;
        }
        setDuration(videoElement.duration);
        setIsSupportFullScreen(isSupportFullScreen);
        changeSilderColor();
    }
    const changeSilderColor = () => {
        if(document.querySelector('.ant-slider-track')) {
            document.querySelector('.ant-slider-track').style.backgroundColor = themeColor || "#fff";
        }
        if(document.querySelector('.ant-slider-handle')) {
            document.querySelector('.ant-slider-handle').style.backgroundColor = themeColor || "#fff";
        }
    }
    //play事件
    const handlePlay = () => {
        setPlaying(true);
    }
    //pause事件
    const handlePause = () => {
        setPlaying(false);
    }
    //ended事件
    const handleEnded = () => {
        setPlaying(false);
        isEndRef.current = true;
    }
    //timeupdate事件
    const handleTimeUpdate = (e) => {
        const videoElement = videoPlayer.current;
        const currentTime = videoElement.currentTime;
        setCurrentTime(currentTime);
    }
    const changeSlider = value => {
        videoPlayer.current.currentTime = value ? value / 1000 : 0;
    }

    //播放器点击事件
    const play = () => {
        pauseAll();
        if(playing){
            videoPlayer.current.pause();
        }else{
            videoPlayer.current.play();
        }
        changeVideo && changeVideo();
    }
    const pauseAll = () => {
        let videos = document.getElementsByTagName('video');
        for (let j = videos.length - 1; j >= 0; j--) {
            videos[j].pause();
        }
    };
    // 暂停
    const pause = () => {
        videoPlayer.current.pause();
        handlePause();
    };
    const changePlaybackRateModal = () => {
        setShowPlaybackRate(!showPlaybackRate);
    }

    const setVideoRate = (rate) => {
        setPlaybackRate(rate);
        setShowPlaybackRate(false);
        videoPlayer.current.playbackRate = Number(rate);
    }
    //全屏按钮
    const requestFullScreen = () => {
        const videoElement = videoWrapPlayer.current;
        if (isFullScreen) {
            exitFullScreen();
            setIsFullScreen(false);
        } else {
            enterFullScreen(videoElement);
            setIsFullScreen(true);
        }
    }

    const playbackRateClick = value => {
        setPlaybackRate(value);
        videoPlayer.current.playbackRate = Number(value);
    };

    const playbackRateMenu1 = (
        <Menu
            selectedKeys={[playbackRate]}
            className={"subtitle_dropdown"}
            onClick={playbackRateClick}>
            {playbackRateMap.map(item => {
                return <Menu.Item key={item.value}>{item.label}</Menu.Item>;
            })}
        </Menu>
    );

    const playbackRateMenu = (
        <div className="subtitle-dropdown">
            {playbackRateMap.map(item => {
                return <div className={`subtitle-dropdown-item ${item.value == playbackRate ? 'active' : ''}`} key={item.value} onClick={() => playbackRateClick(item.value)}>{item.label}</div>;
            })}
        </div>
    );

    return (
        <div
            ref={videoWrapPlayer}
            className="video-page-wrap"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {videoUrl ?
                <Fragment>
                    <div className="video-player">
                        <video className="video-player-element"
                               id={id}
                               muted={false}
                               controls={false}
                               ref={videoPlayer}
                               object-fit="contain"
                               x5-playsinline="true"
                               playsInline={true}
                               webkit-playsinline="true"
                               x-webkit-airplay="allow"
                               preload="auto"
                               onCanPlayThrough={handleCanPlay}
                               onPlay={handlePlay}
                               onPause={handlePause}
                               onEnded={handleEnded}
                               onTimeUpdate={handleTimeUpdate}
                               onClick={play}
                               autoPlay={false}
                               src={videoUrl}>
                            不支持video
                        </video>
                        <div className="video-play-cover"
                             style={{display: !playing || showPoint ? "block" : "none"}}
                             onClick={play}>
                            <div className="video-play-cover-inner">
                                {
                                    playing?
                                        <i className="iconfont icon-lull"></i>:
                                        <i className="iconfont icon-play"></i>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="video-controls-box">
                        <div className="video-controls-wrap">
                            <div className="video-controls-play">
                            <span className="video-controls-btn" onClick={play}>
                                <i className={`iconfont ${playing ? 'icon-lull' : 'icon-play'}`}></i>
                            </span>
                            </div>
                            <div className="video-controls-time">
                                {createTimeStr(currentTime)} / <span>{createTimeStr(duration)}</span>
                            </div>
                            {isPlaybackRate && (
                                <Dropdown
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                    overlay={playbackRateMenu}
                                    overlayClassName={"media_subtitle_dropdown"}
                                    placement="topCenter">
                                    <div className="video-play-rate">
                                        倍速
                                    </div>
                                </Dropdown>
                            )}
                            {
                                isSupportFullScreen?
                                    <div className="video-controls-full-screen">
                                        <span className="video-controls-btn" onClick={requestFullScreen}>
                                            {
                                                isFullScreen?
                                                    <i className="iconfont icon-small-screen"></i>:
                                                    <i className="iconfont icon-full-screen"></i>
                                            }
                                        </span>
                                    </div> :null
                            }
                        </div>
                        {duration ?
                            <Slider tipFormatter={null} onChange={changeSlider} value={currentTime * 1000} max={duration * 1000} />
                            : <Slider tipFormatter={null} value={0} />
                        }
                    </div>
                </Fragment> :
                    <div className="video-play-cover-novideo"
                         onClick={playNoVideo}>
                        <img src={poster} className="video-play-cover-novideo-poster"/>
                        <div className="video-play-cover-inner">
                            <i className="iconfont icon-play"></i>
                        </div>
                    </div>
                }
        </div>
    )
};

export default VideoPage;